"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.langTags = void 0;
var langtags_json_1 = __importDefault(require("./data/langtags.json"));
exports.langTags = langtags_json_1.default;
exports.langTags.push({
    full: 'qaa',
    iso639_3: 'qaa',
    localname: 'Unknown',
    name: 'Unknown',
    regionname: 'anywhere',
    script: 'Latn',
    sldr: false,
    tag: 'qaa',
});
